import { render } from "./Versions.vue?vue&type=template&id=5a32a35a"
import script from "./Versions.vue?vue&type=script&lang=js"
export * from "./Versions.vue?vue&type=script&lang=js"

import "./Versions.vue?vue&type=style&index=0&id=5a32a35a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__